/**
 * utils.ts — Utilidades compartidas para datos de mocks.
 */

const daysAgo = (n: number, hours = 0): string =>
  new Date(Date.now() - n * 86_400_000 - hours * 3_600_000).toISOString();

export { daysAgo };
